import React from 'react'
import { Button, Card, Form, Select, Space } from 'antd'
import S3Upload, { AllowedFormats } from '@a4b/ui/src/modules/monetisation/molecules/S3Upload'
import { YODA_CDN_URL, YODA_PRESIGN_URL } from '@/utils/constants'

const { Option } = Select

type Props = {
    legend: string
    /** Form.List name (e.g. "banners", or ['about_us_media']) */
    name: string | (string | number)[]
    /** Allowed extensions to pass to S3Upload */
    allowed?: string[]
}

const normFileList = (e: any) => Array.isArray(e) ? e : (e?.fileList ?? [])

export default function MediaListFieldset({ legend, name, allowed }: Props) {
    const allowedExts = Array.isArray(allowed) && allowed.length
        ? allowed
        : [AllowedFormats.PNG, AllowedFormats.JPEG, AllowedFormats.JPG, AllowedFormats.WEBP, AllowedFormats.GIF, AllowedFormats.MP4]

    return (
        <Card size="small" title={legend} bordered>
            <Form.List name={name}>
                {(fields, { add, remove }) => (
                    <>
                        {fields.map((field) => (
                            <Space key={field.key} align="start" style={{ width: '100%', marginBottom: 8 }}>
                                {/* URL as fileList for S3Upload */}
                                <Form.Item
                                    name={[field.name, 'url']}
                                    valuePropName="fileList"
                                    getValueFromEvent={normFileList}
                                    style={{ marginBottom: 0, width: 420 }}
                                    rules={[
                                        {
                                            validator: async (_: any, v: any[]) => {
                                                if (!v || v.length === 0) return Promise.reject('')
                                                return Promise.resolve()
                                            },
                                        },
                                    ]}
                                >
                                    <S3Upload
                                        cdnUrl={YODA_CDN_URL}
                                        preSignUrl={YODA_PRESIGN_URL}
                                        min={1}
                                        max={1}
                                        allowedFileExtension={allowedExts}
                                        skipTruncate={true}
                                    />
                                </Form.Item>

                                {/* Optional explicit type; we still infer when saving if empty */}
                                <Form.Item name={[field.name, 'type']} style={{ marginBottom: 0, width: 160 }}>
                                    <Select allowClear placeholder="media type (opt)">
                                        <Option value="image">Image</Option>
                                        {/* <Option value="video">Video</Option>
                                        <Option value="audio">Audio</Option> */}
                                    </Select>
                                </Form.Item>

                                <Button onClick={() => remove(field.name)} danger>Remove</Button>
                            </Space>
                        ))}
                        <Button onClick={() => add({ url: [], type: undefined })}>+ Add</Button>
                    </>
                )}
            </Form.List>
        </Card>
    )
}
